exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".imosSdk-video{height:100%!important;width:100%!important}.btnCont{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.controlImg{width:30px}.controlImg_up{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.controlImg_right{margin-left:30px;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.controlImg_down{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.tc{text-align:center;text-align:-webkit-center}", ""]);

// exports
